import $ from 'jquery'

export const binds = () => {
  // ---------------- update account details

  $('body').on('click', '[data-apply-job-form]', function (event) {
    event.preventDefault()
    var dataSet = JSON.parse(JSON.stringify(event.target.dataset || {}))

    if (dataSet?.jobTitle) {
      $('#job-apply-form-title').html(dataSet.jobTitle)
    }

    if (dataSet?.jobId >= 0) {
      localStorage.setItem('activeJobID', dataSet.jobId)
    }
  })

  // ---------------- create subaccount
  $('body').on('click', '[data-apply-dream-job-form]', function (event) {
    event.preventDefault()
    var dataSet = JSON.parse(JSON.stringify(event.target.dataset || {}))

    if (dataSet?.jobId == 0) {
      localStorage.setItem('activeJobID', '0')
    }
  })
}
